import React from 'react';

import { QueryConfigProvider } from 'platform-components/src/components/query-config-provider';
import { Route } from 'platform-components/src/components/router/router';

import App from 'common.components/app/app';

import { labSaga } from '../../../../sagas';
import TeacherApp from '../teacher-app/teacher-app';

export const routes = (
    <Route
        path="/"
        render={(props) => (
            <App {...props} rootSaga={labSaga}>
                <QueryConfigProvider>
                    <TeacherApp />
                </QueryConfigProvider>
            </App>
        )}
    />
);
